import React, { useCallback, useEffect, useState } from "react";
import TransactionTable from "../components/TransactionTable";
import LoadingIcon from "../components/LoadingIcon";

const columns = [
  {
    name: "Amount",
    selector: (row) => (
      <div
        className={`
          ${
            row.transactionType === "Deposit" ||
            row.transactionType === "Earning"
              ? "text-green-600"
              : ""
          } 
           ${row.transactionType === "withdrawal" ? "text-red-600" : ""} ${
          row.transactionType === "Subscription" ? "text-blue-600" : ""
        } 
        `}
      >
        $ {parseInt(row.amount).toFixed(2)}
      </div>
    ),
    sortable: true,
  },
  {
    name: "Transaction Type",
    selector: (row) => <div className="capitalize"> {row.transactionType}</div>,
  },
  {
    name: "Date",
    selector: (row) => new Date(row.createdAt).toDateString(),
    sortable: true,
  },
];

const Activity = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");

  const getActivity = useCallback(async () => {
    setLoading(true);
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}activity/all`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          token,
        },
      }
    );

    const data = await response.json();

    if (data.status) {
      setTransactions(data.userTransactions);
    }
    setLoading(false);
  }, [token]);

  useEffect(() => {
    getActivity();
  }, [getActivity]);
  return (
    <div className="min-h-screen">
      <div className="mb-9">
        <h6 className="font-bold text-2xl text-white">Activity Logs</h6>
      </div>
      {loading ? (
        <div className="h-screen flex items-center justify-center">
          <LoadingIcon />
        </div>
      ) : (
        <TransactionTable transactions={transactions} columns={columns} />
      )}
    </div>
  );
};

export default Activity;
